module.exports = __webpack_public_path__ + "img/France.ec32aed9.png";